import { Outlet } from 'react-router-dom';
import SiteHeader from '../components/SiteHeader';

export default function AppShell() {
  return (
    <>
      <SiteHeader />
      <Outlet />
    </>
  );
}
